import { DocumentPDFField } from '~/lib/pdfViewer/types';
import type { CommentedHighlight } from '~/components/ui/vendor/pdf/pdf_container/types';
import { fieldBBox2ReactPDFBBox } from '~/lib/pdfViewer/fieldBBox2ReactPDFBBox';

export function fieldsToPDFHighlights(document_fields: DocumentPDFField[]) {
  const result: CommentedHighlight[] = [];
  // for (const { fields } of document_fields) {
  for (const field of document_fields) {
    if (!field.sourceBoundingBox) {
      continue;
    }
    // Happen to be the same right now, but actually type conversion
    // from internal bounding box to react-pdf
    const bbox = fieldBBox2ReactPDFBBox(field.sourceBoundingBox);

    result.push({
      id: field.fieldId,
      type: 'text',
      content: {},
      position: {
        boundingRect: bbox,
        rects: [bbox],
      },
      comment: field.field,
    });
  }
  // }
  return result;
}
